import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ServerUrl } from 'src/utils/APIPath';
import { TermsDetail, TermsDetailRequest } from 'src/types/type';
import CmdType from 'src/service/constants';
import { addApiBreadcrumb } from 'src/utils/sentry/breadcrumb';
import { captureServerError, captureUnexpectedErrCode } from 'src/utils/sentry/api';
import { captureTermsDetailError } from 'src/utils/sentry/validation';
import { ERR_CODES } from 'src/types/errcode';

export const useTermsDetailQuery = (requestID: string, data: TermsDetailRequest) => {
  const initData = {
    TermsTitle: '',
    TermsContents: '',
  };
  const httpData = {
    Header: {
      CmdType: CmdType.gettermsdetail,
      CallApp: "terms",
      RequestID: requestID,
    },
    Body: data,
  };
  return useQuery([CmdType.gettermsdetail, data], async () => {
    addApiBreadcrumb('request', { cmdType: CmdType.gettermsdetail });

    return await axios
      .post(ServerUrl, JSON.stringify(httpData), {
        withCredentials: true,
      })
      .then((response): TermsDetail => {
        const { Header, Body } = response.data;
        if (Header?.ErrCode !== ERR_CODES.SUCCESS) {
          addApiBreadcrumb('response', {
            cmdType: CmdType.gettermsdetail,
            errCode: Header?.ErrCode,
            errMsg: Header?.ErrMsg,
          });
          captureUnexpectedErrCode(Header);
          return initData;
        }
        captureTermsDetailError(data.Telecom, data.Idx, Body);
        return Body ?? initData;
      })
      .catch((error) => {
        captureServerError(error, CmdType.gettermsdetail);
        throw error;
      });
    },
    { refetchOnWindowFocus: false },
  );
};
